const navigateWithFullPageReload = (url: string) => {
  const location = window.top ? window.top.location : window.location;

  location.href = url;
};

export default navigateWithFullPageReload;
